import { useCallback, useEffect, useState } from 'react';

const ACTIVITY_EVENTS: (keyof WindowEventMap)[] = ['mousemove', 'keydown', 'scroll', 'click'];

/** Locks after `timeoutMs` of no user activity. Also exposes manual lock / unlock. */
export function useInactivityLock(timeoutMs: number) {
  const [isLocked, setIsLocked] = useState(false);

  useEffect(() => {
    if (isLocked) return;
    let timer = window.setTimeout(() => setIsLocked(true), timeoutMs);
    const reset = () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => setIsLocked(true), timeoutMs);
    };
    ACTIVITY_EVENTS.forEach((name) => window.addEventListener(name, reset, { passive: true }));
    return () => {
      window.clearTimeout(timer);
      ACTIVITY_EVENTS.forEach((name) => window.removeEventListener(name, reset));
    };
  }, [isLocked, timeoutMs]);

  const lock = useCallback(() => setIsLocked(true), []);
  const unlock = useCallback(() => setIsLocked(false), []);

  return { isLocked, lock, unlock };
}
